<template>
  <div>
    <template v-if="loaded">
      <template v-if="mode == 'create'">
        <topbar :showBack="true" :menu="false" @back="stepCreatorBack" :progressIndex="childindex" :progressMax="3" />
        <div class="p-3">
          <div class="my-4">
            <profile-pic-editor />
          </div>
          <profile-editor @persisted="gotoOverview" @changepage="childindex = $event" ref="profileCreator" />
        </div>
      </template>
      <template v-if="mode == 'edit'">
        <topbar :showBack="true" @back="stepEditorBack" :progressIndex="childindex" :progressMax="3" />
        <div class="p-3">
          <div class="my-4">
            <profile-pic-editor />
          </div>
          <profile-editor @persisted="show" @cancelled="childindex = 0; show()" :allowCancel="true" @changepage="childindex = $event" ref="profileEditor" />
        </div>
      </template>
      <template v-if="mode == 'show'">
        <topbar title="Profilo personale" :showBack="true" @back="gotoOverview" />
        <div class="p-3 max-w-3xl mx-auto">
          <div class="my-4">
            <profile-pic-editor />
          </div>
          <card title="Dettagli" class="my-8" :action="{label: 'Modifica', method: edit}">
            <profile-summary  @requestEdit="edit" />
          </card>
          <card :title="$t('label.credentials')" class="my-8" :action="{label: 'Modifica', method: editCreds}">
            <credentials-editor ref="credseditor" />
          </card>
        </div>
        <div class="text-sm p-3 max-w-3xl mx-auto">
          <div class="m-3 mb-2 font-bold">Informazioni</div>
          <a :href="feedbackUrl" target="_blank" class="block border-b border-line p-3">Segnala un problema</a>
          <router-link :to="{name: 'guide'}" class="block border-b border-line p-3">Guida</router-link>
          <router-link :to="{name: 'privacypolicy'}" class="block border-b border-line p-3">Trattamento dei dati</router-link>
          <router-link :to="{name: 'credits'}" class="block border-b border-line p-3">Crediti</router-link>
          <a href="https://goto.lidate.ch" target="_blank"  class="block p-3">lidate.ch</a>
        </div>
          
        <div class="flex flex-col my-2 p-3 max-w-3xl mx-auto">
          <button class="btn btn-1" @click="logout()">esci</button>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import ProfileEditor from "@/components/ProfileEditor";
import ProfileSummary from "@/components/ProfileSummary";
import ProfilePicEditor from "@/components/ProfilePicEditor";
import CredentialsEditor from "@/components/CredentialsEditor";
import { mapActions } from 'vuex';


export default {
  data() {
    return {
      loaded: false,
      mode: 'show',
      childindex: 0
    }
  },
  components: {
    ProfileEditor,
    ProfilePicEditor,
    ProfileSummary,
    CredentialsEditor
  },
  computed: {
    feedbackUrl() {
      const ua = encodeURIComponent(window.navigator.userAgent)
      const id = encodeURIComponent(this.$store.getters.profile.id)
      return `https://docs.google.com/forms/d/e/1FAIpQLSfRQR3-kbRSDpSDaSp3LgmMFRwrlyvQ-qV8_CyONGz3JCsh4w/viewform?usp=pp_url&entry.37775529=${id}&entry.1606619812=${ua}`
    },
    profile() {
      return this.$store.getters.profile
    }
  },
  async mounted() {
    await this.$store.dispatch('bindProfile')
    const prof = this.$store.getters.profile
    if(prof) {
      this.mode = 'show'
    } else {
      this.mode = 'create'
    }
    this.loaded = true
  },
  methods: {
    edit() {
      this.mode = 'edit'
    },
    editCreds() {
      this.$refs.credseditor.edit()
    },
    show() {
      this.mode = 'show'
    },
    gotoOverview() {
      this.$router.push({name: 'Overview'})
    },
    stepCreatorBack() {
      this.$refs.profileCreator.goBack()
    },
    stepEditorBack() {
      if(this.childindex === 0) {
        this.show()
      } else {
        this.$refs.profileEditor.goBack()
      }
    },
    ...mapActions(['logout'])
  }
}
</script>

<style>

</style>